import React from 'react';

import './animation.css';

  function Animation() {
    return (
      <div className="blob">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635.4 646.8">
      <path class="st0" d="M247.3,188.1c92.1-66,246.7-213.7,321.4-97.3c56,87.2,36.5,437.8-83.4,491.6c-94.5,42.5-432.5,3.6-446.5-99
	C18,330.5,163.1,248.4,247.3,188.1z"/> 
    
  </svg>
      </div>
    );
  }
  
  
export default Animation;